// extracted by mini-css-extract-plugin
export default {"simulateButton":"StartSimulationButton_simulateButton__GPSEI"};